import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

const AuthRoute = ({ component: Component, ...arg }) => {
  const isLogin = useSelector(({ user }) => user.isLogin)
  return (
    <Route
      {...arg}
      render={props =>
        isLogin ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              search:
                props.location.pathname !== '/' &&
                `?from=${props.location.pathname + props.location.search}`
            }}
          />
        )
      }
    />
  )
}

export default AuthRoute
